/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [{
    path: '/Demo',
    name: 'Demo',
    view: 'Demo'
},
{
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
},
{
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
},
{
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'
},
{
    path: '/typography',
    view: 'Typography'
},
{
    path: '/icons',
    view: 'Icons'
},
{
    path: '/maps',
    view: 'Maps'
},
{
    path: '/notifications',
    view: 'Notifications'
},
{
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
},
{
    path: '/Racing',
    name: 'Racing',
    view: 'Racing'
},
{
    path: '/Football',
    name: 'Football',
    view: 'Football'
}, {
    path: '/FootballXML',
    name: 'FootballXML',
    view: 'FootballXML'
},
{
    path: '/latestraceresult',
    name: 'LatestRaceResult',
    view: 'LatestRaceResult'
},
{
    path: '/racingoncc',
    name: 'RacingOncc',
    view: 'RacingOncc'
},
{
    path: '/footballoncc/:type',
    name: 'footballoncc',
    view: 'FootballOncc'
},
{
    path: '/footballaicai',
    name: 'footballaicai',
    view: 'FootballAicai'
},
{
    path: '/footballhkjc',
    name: 'footballhkjc',
    view: 'FootballHkjc'
},
{
    path: '/racingschedule',
    name: 'RacingSchedule',
    view: 'RacingSchedule'
},
{
    path: '/bad11History',
    name: 'Bad11勁揪',
    view: 'bad11History'
},
{
    path: '/privacypolicy',
    name: 'Privacy Policy',
    view: 'PrivacyPolicy'
},{
    path: '/MobileApp',
    name: 'Mobile App',
    view: 'MobileApp'
}
]